import React from 'react';

import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { createStyles, makeStyles, Theme } from '@material-ui/core';


const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    chevronContainer: {
      opacity: '70%',
      width: '30px',
      height: '50px',
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      '&:hover, &:focus': {
        opacity: '100%',
        cursor: 'pointer',
      },
    },
    chevron: {
      opacity: 'inherit',
      position: 'absolute',
      top: 0,
      transform: 'rotate(90deg)',
      animationDuration: '2s',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
      animationName: '$moveChevron',
    },
    '@keyframes moveChevron': {
      '0%': {
        top: '0px'
      },
      '50%': {
        top: '15px'
      },
      '100%': {
        top: '0px'
      }
    },
  }),
)

const ScrollDownChevron = ({ chevronColor }: { chevronColor: string }) => {
  const classes = useStyles();
  return (
    <div className={classes.chevronContainer}>
      <DoubleArrowIcon className={classes.chevron} fontSize='large' style={{color: chevronColor}}/>
    </div>
  )
}

export default ScrollDownChevron;
